import BrowserLanguageDetector from 'i18next-browser-languagedetector';
import configLanguageDetector from './configLanguageDetector';
/**
 * The ordered list (by name) of language detectors to be utilized as backends
 * by the singleton language detector for Web.
 *
 * Priority order: config first (for default language), then localStorage, then querystring
 * Navigator detection is optional and comes last to avoid flash of wrong language.
 *
 * @type {Array<string>}
 */
const order = [
    configLanguageDetector.name,
    'localStorage',
    'querystring'
];
// Allow i18next to detect the system language reported by the Web browser
// itself - but only after checking config and localStorage first
interfaceConfig.LANG_DETECTION && order.push('navigator');
/**
 * The singleton language detector for Web.
 */
const languageDetector = new BrowserLanguageDetector(
/* services */ null, 
/* options */ {
    caches: ['localStorage'],
    lookupLocalStorage: 'language',
    lookupQuerystring: 'lang',
    order
});
// @ts-ignore
languageDetector.addDetector(configLanguageDetector);
export default languageDetector;
